var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import InputSliderControlled from "./InputSliderControlled.js";
var InputSliderUncontrolled = function (props) {
    var defaultValue = props.defaultValue, defaultMinValue = props.defaultMinValue, defaultMaxValue = props.defaultMaxValue, onChange = props.onChange, min = props.min, max = props.max, range = props.range;
    var _a = React.useState(defaultValue || min), value = _a[0], setValue = _a[1];
    var _b = React.useState(defaultMinValue || min), minValue = _b[0], setMinValue = _b[1];
    var _c = React.useState(defaultMaxValue || max), maxValue = _c[0], setMaxValue = _c[1];
    var handleChange = function (args) {
        if (args.value !== undefined)
            setValue(args.value);
        if (args.minValue !== undefined)
            setMinValue(args.minValue);
        if (args.maxValue !== undefined)
            setMaxValue(args.maxValue);
        if (onChange)
            onChange(args);
    };
    if (range) {
        return (React.createElement(InputSliderControlled, __assign({}, props, { minValue: minValue, maxValue: maxValue, defaultValue: undefined, defaultMinValue: undefined, defaultMaxValue: undefined, onChange: handleChange })));
    }
    return (React.createElement(InputSliderControlled, __assign({}, props, { value: value, defaultValue: undefined, defaultMinValue: undefined, defaultMaxValue: undefined, onChange: handleChange })));
};
export default InputSliderUncontrolled;
